import axios, { AxiosResponse } from "axios";
import { handleApiError } from "src/common/api/apiErrorHandler";
import { BranchReason } from "src/common/types/branch";
import { DeepLink } from "../types/deepLink";

export default class MarketingLinksApi {
  static async getDeepLink(publicKey: string): Promise<DeepLink | null> {
    let url = this.baseUrl + `/dl/${encodeURIComponent(publicKey)}`;

    try {
      const response: AxiosResponse<DeepLink> = await axios.get<DeepLink>(url);
      if (response.status === 204) {
        return null;
      } else {
        return response.data;
      }
    } catch (error) {
      return handleApiError(error);
    }
  }

  static async isBranchAvailable(branchReason: BranchReason): Promise<boolean> {
    const reqUrl = this.baseUrl + `/branchAvailability`;

    try {
      const response: AxiosResponse<boolean> = await axios.post<boolean>(reqUrl, branchReason);
      if (response.status === 204) {
        return false;
      } else {
        return response.data;
      }
    } catch (error) {
      return handleApiError(error);
    }
  }

  private static baseUrl: string = "/api/links/marketing";
}
